import URI from 'urijs'

export default
function (ngModule) {
    ngModule.directive('tveyesDocumentCard', [function(){
            return {
                restrict: 'E',
                template: require('./mw-card.html'),
                controllerAs: 'vm',
                controller: 'TVEyesDocumentCardController',
                scope: {
                    document: '=?',
                    displaySettings: '=',
                    showDuplicates: '&',
                    documentClick: '&',
                    overlaySentiment: '&',
                    onBylineClick: '&?',
                    isInfluencerDatabaseEntitled:'=',
                    isNarrowCard: '=',
                    showFooter: '=',
                    showOpenDocumentIcon: '=',
                    minimumImageSize: '='
                }
            };
        }])
        .controller('TVEyesDocumentCardController', [
            '$scope',
            'ContentBehaviorService',
            'translationService',
            'GeoService',
            'ENV_FEATURE_TOGGLE_SETTINGS',
            TVEyesDocumentCardController
        ]);

    function TVEyesDocumentCardController($scope, ContentBehaviorService, translationService, GeoService, ENV_FEATURE_TOGGLE_SETTINGS) {

        this.showHideUnhideOption = false;
        this.mediaAvailable = false;

        //retrieving toggle synchronously
        if (ENV_FEATURE_TOGGLE_SETTINGS && ENV_FEATURE_TOGGLE_SETTINGS.hideUnhideDocumentsToggle && ENV_FEATURE_TOGGLE_SETTINGS.hideUnhideDocumentsToggle.active) {
            this.showHideUnhideOption = true;
        }

        this.onMediaAvailable = function onMediaAvailable() {
            this.mediaAvailable = true;
        }.bind(this);

        this.imageAvailableOptions = {
            onMediaAvailable: this.onMediaAvailable,
            minimumImageSize: $scope.minimumImageSize
        };

        function getAuthorName(author) {
            if(author.authorInfo && author.authorInfo.structuredName && author.authorInfo.structuredName.firstName && author.authorInfo.structuredName.lastName) {
                return author.authorInfo.structuredName.firstName + (author.authorInfo.structuredName.middleName ? ' ' + author.authorInfo.structuredName.middleName : '') + ' ' + author.authorInfo.structuredName.lastName;
            }
            else if($scope.document.sourceId && $scope.document.sourceId.indexOf('adhoc:') > -1 && (!author.authorInfo || !author.authorInfo.structuredName) && author.name) {
                return author.name;
            }
        }

        function getAuthors(document) {
            if(!document.authors) {
                return [];
            }

            return document.authors.reduce(function(authors, author) {
                var isAuthorClickable = !!(author.id && $scope.isInfluencerDatabaseEntitled);

                if(getAuthorName(author)) {
                    authors.push({
                        name: getAuthorName(author),
                        url: (isAuthorClickable && '/influencers/contact/view/' + author.id) || '',
                        onClick: function onClick() {
                            if(isAuthorClickable && typeof($scope.onBylineClick) === 'function') {
                                $scope.onBylineClick({ author: author });
                            }
                        }
                    });
                }

                return authors;
            }, []);
        }

        function onDocumentClick(url, event) {
            if(url) {
                return $scope.documentClick({
                    event: event,
                    document: $scope.document,
                    url: url
                });
            }
        }

        function getLocalizedMoreArticlesText(count) {
            let moreArticleText = "";
            if (count > 0) {
                if (count === 1) {
                    moreArticleText = translationService.getLocalizedString('1 more article');
                } else {
                    moreArticleText = translationService.getLocalizedString('[[numArticles]] more articles', {numArticles: count})
                }
                return moreArticleText;
            }
        }

        var update = function update() {
            let hiddenDupDocsCount = 0,
                openingText;

            this.document = $scope.document;
            this.documentId = $scope.document.documentId;
            this.documentUrl = $scope.document.paywallUrl || $scope.document.redirectUrl || $scope.document.url || $scope.document.sourceUrl;
            this.imagesVisible = $scope.displaySettings.images;
            this.avatarsVisible = $scope.displaySettings.avatar;
            this.isNarrowCard = $scope.isNarrowCard;
            this.showFooter = $scope.showFooter;
            this.showOpenDocumentIcon = $scope.showOpenDocumentIcon;
            this.mediaType = $scope.document.mediaType;
            this.mediaTypeIcon = $scope.document.mediaTypeIcon || $scope.document.mediaType;
            this.avatarTitle = $scope.document.title;
            this.avatarLinkUrl = this.documentUrl;
            this.sourceName = $scope.document.source || translationService.getLocalizedString('Unknown');
            this.sourceUrl = $scope.document.sourceUrl;
            this.authors = getAuthors($scope.document);
            this.date = $scope.document.date;
            this.title = $scope.document.title;
            this.onAvatarClick = onDocumentClick.bind(this, this.avatarLinkUrl);
            this.onSourceIconClick = onDocumentClick.bind(this, this.documentUrl);
            this.onSourceNameClick = onDocumentClick.bind(this, $scope.document.sourceUrl);
            this.onDocumentOpenClick = onDocumentClick.bind(this, this.documentUrl);
            this.onTitleClick = onDocumentClick.bind(this, this.documentUrl);
            this.tags = ($scope.displaySettings.displayTags && $scope.document.tags) || [];
            this.keywords = ($scope.displaySettings.keywords && $scope.document.keywords) || [];
            this.dupDocsCount = $scope.document.dupDocsCount || ($scope.document.dupDocs && $scope.document.dupDocs.length) || 0;
            this.reach = $scope.document.reach;
            this.sentiment = $scope.document.sentiment;
            this.isSentimentModified = $scope.document.isSentimentModified;
            this.originalSentiment = $scope.document.originalSentiment;
            this.onOverlaySentimentClick = $scope.overlaySentiment;
            this.text = [];
            this.smallText = [];

            if ($scope.document.sourceId && $scope.document.sourceId.indexOf('tve') > -1) {
                this.avatarImageUrl = `http://tveyecons.meltwater.net/icons/${$scope.document.sourceId}`;
            }

            GeoService.convertCountryCodeToCode3($scope.document.country).then(function(code) {
                this.countryCode = code;
            }.bind(this));

            if($scope.document.sourceId && $scope.document.sourceId.indexOf('adhoc:') > -1){
                let ingress = $scope.document.ingress;
                if(ingress) {
                    if(ingress.indexOf('...', ingress.length - 3) > -1) {
                        ingress = ingress.slice(0, ingress.length - 3);
                    }

                    // so the openingText is the ingress as long as the matchsentence does not contain
                    // the ingress (minus some ellipsis)
                    if($scope.document.matchSentence.indexOf(ingress) === -1 ) {
                        openingText = ingress;
                    }
                }
            } else {
                openingText = $scope.document.ingress
            }

            if ($scope.displaySettings.hitSentence && $scope.document.matchSentence) {
                this.text.push($scope.document.matchSentence)
            }

            if ($scope.displaySettings.openingText && openingText) {
                this.smallText.push(openingText)
            }

            if (this.showHideUnhideOption) {
                hiddenDupDocsCount = angular.isArray($scope.document.dupDocs) && $scope.document.dupDocs.length ? $scope.document.dupDocs.filter(function (dupDoc) {
                        return dupDoc.isHidden;
                    }).length : 0;
                this.visibleDupDocsCount = this.dupDocsCount - hiddenDupDocsCount;

                //not using ng-pluralize with ContentBehaviorService.generateMoreArticleObject
                //since we need to update the number with hide and unhide.
                //see: http://stackoverflow.com/questions/22339108/ng-pluralize-when-bound-to-a-variable
                this.moreArticlesLinkText = getLocalizedMoreArticlesText(this.visibleDupDocsCount);
            } else {
                this.dupDocsCountWhen = ContentBehaviorService.generateMoreArticleObject($scope.document);
            }

            this.onShowDuplicatesClick = function (e) {
                return $scope.showDuplicates({
                    documentId: $scope.document.documentId
                });
            };
        }.bind(this);

        $scope.$watch('document', update, true);
        $scope.$watch('displaySettings', update, true);
        $scope.$watch('isInfluencerDatabaseEntitled', update, true);

        update();
    }
}



// WEBPACK FOOTER //
// ./source/components/document-card/tveyes-document-card.js